/**
 * Defs - SVG Definitions for special bond types
 *
 * Defines reusable SVG patterns for:
 * - Dash bonds (dCToC, dCToNC, dNCToC, dNCToNC)
 * - Wedge bonds (wCToC, wCToNC, wNCToC, wNCToNC)
 * - Squiggle bonds (sCToC, sCToNC, sNCToC, sNCToNC)
 * - Arrow markers (arrowhead, fishheadleft, fishheadright)
 *
 * Copied from @alchemiesolns/svg-container to avoid dependency during rebuild.
 */

export const Defs = () => {
    return (
        <defs>
            {/* Dash bond definitions */}
            <g id="dCToC" transform="translate(1,0) scale(.5, 1)">
                    <path d="M1.82996 1H2.17218" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.66003 2H2.34448" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.48999 3L2.50999 3" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.31995 4L2.67995 4" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.1499 5H2.8499" stroke="black" strokeWidth="0.45" />
                    <path d="M0.97998 6L3.01998 6" stroke="black" strokeWidth="0.45" />
                    <path d="M0.809937 7L3.18994 7" stroke="black" strokeWidth="0.45" />
            </g>
            <g id="dCToNC" transform="translate(.5,-.5) scale(.7, 1)">
                    <path d="M1.82996 1H2.17218" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.66003 2H2.34448" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.48999 3L2.50999 3" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.31995 4L2.67995 4" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.1499 5H2.8499" stroke="black" strokeWidth="0.45" />
            </g>
            <g id="dNCToC" transform="translate(1,2) scale(.7, 1)">
                    <path d="M1.82996 1H2.17218" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.66003 2H2.34448" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.48999 3L2.50999 3" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.31995 4L2.67995 4" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.1499 5H2.8499" stroke="black" strokeWidth="0.45" />
                    <path d="M0.97998 6L3.01998 6" stroke="black" strokeWidth="0.45" />
            </g>
            <g id="dNCToNC" transform={"translate(.5,1.1) scale(.7, 1)"}>
                    <path d="M1.82996 1H2.17218" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.66003 2H2.34448" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.48999 3L2.50999 3" stroke="black" strokeWidth="0.45"/>
                    <path d="M1.31995 4L2.67995 4" stroke="black" strokeWidth="0.45"/>
            </g>

            {/* Wedge bond definitions  */}
            <g id="wCToC" transform="translate(0, .35)">
              <path d="M0.225 6.5H2.775L1.5 0L0.225 6.5Z" fill="black"/>
            </g>
            <g id="wCToNC" transform="translate(0, .35)">
              <path fillRule="evenodd" clipRule="evenodd" d="M1.5 0L0.33125 4.5H2.66875L1.5 0Z" fill="black"/>  
            </g>
            <g id="wNCToC" transform="translate(0, .35)">
              <path d="M0.225 6.5H2.775L1.5 0L0.225 6.5Z" fill="black"/>
            </g>
            <g id="wNCToNC" transform="translate(0, 1.75)">
              <path fillRule="evenodd" clipRule="evenodd" d="M1.5 0L0.33125 3.5H2.66875L1.5 0Z" fill="black"/>
            </g>

            {/* Squiggle bond definitions  */}
            <g id="sCToC" transform="scale(.8) translate(0,0)">
                <path d="M0.999943 9C1.99986 9 1.99986 7.5 0.999943 7.5C2.78354e-05 7.5 9.95398e-06 6 0.999943 6C1.99988 6 2 4.5 0.999943 4.5C-0.00011307 4.5 0 3 0.999943 3C1.99989 3 2 1.5 0.999943 1.5C0.612958 1.5 0.375722 1.27539 0.288235 1C0.149636 0.56372 0.386872 0 0.999943 0" stroke="black" strokeWidth="0.34"/>
            </g>
            <g id="sCToNC" transform="translate(0 0) scale(.8 .6)">
            <path d="M0.999943 9C1.99986 9 1.99986 7.5 0.999943 7.5C2.78354e-05 7.5 9.95398e-06 6 0.999943 6C1.99988 6 2 4.5 0.999943 4.5C-0.00011307 4.5 0 3 0.999943 3C1.99989 3 2 1.5 0.999943 1.5C0.612958 1.5 0.375722 1.27539 0.288235 1C0.149636 0.56372 0.386872 0 0.999943 0" stroke="black" strokeWidth="0.34"/>
            </g>
            <g id="sNCToC">
            <path d="M0.999943 9C1.99986 9 1.99986 7.5 0.999943 7.5C2.78354e-05 7.5 9.95398e-06 6 0.999943 6C1.99988 6 2 4.5 0.999943 4.5C-0.00011307 4.5 0 3 0.999943 3C1.99989 3 2 1.5 0.999943 1.5C0.612958 1.5 0.375722 1.27539 0.288235 1C0.149636 0.56372 0.386872 0 0.999943 0" stroke="black" strokeWidth="0.34"/>
            </g>
            <g id="sNCToNC" transform="translate(0 2.3) scale(.8 .4)">
            <path d="M0.999943 9C1.99986 9 1.99986 7.5 0.999943 7.5C2.78354e-05 7.5 9.95398e-06 6 0.999943 6C1.99988 6 2 4.5 0.999943 4.5C-0.00011307 4.5 0 3 0.999943 3C1.99989 3 2 1.5 0.999943 1.5C0.612958 1.5 0.375722 1.27539 0.288235 1C0.149636 0.56372 0.386872 0 0.999943 0" stroke="black" strokeWidth="0.34"/>
            </g>

            {/* Arrow markers */}
            <marker
            id="fishheadleft"
            markerWidth="10"
            markerHeight="7"
            refX="1.25"
            refY="2"
            orient="auto"
            markerUnits="strokeWidth">
                <path d="M0 0L4 2.5H0C0 2.5 0.405284 1.92622 0.5 1.5C0.674648 0.714085 0 0 0 0Z" fill="#BE0000"/>
          </marker>
          <marker
            id="fishheadright"
            markerWidth="10"
            markerHeight="7"
            refX="1.25"
            refY="3.6"
            orient="auto"
            markerUnits="strokeWidth">
                <path d="M0 0.5H4L0 3C0 3 0.587324 2.11127 0.5 1.5C0.438253 1.06777 0 0.5 0 0.5Z"
                    fill="#BE0000"
                    transform="translate(0, 2.5)" />
          </marker>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="1.25"
            refY="2"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M0 0L4 2L0 4V0Z" fill="#BE0000"/>
          </marker>

          {/* Highlight arrowhead for selection feedback - 50% larger, compensated for 2.5x strokeWidth */}
          <marker
            id="arrowhead-highlight"
            markerWidth="6"
            markerHeight="4.2"
            refX="0.75"
            refY="1.2"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M0 0L2.4 1.2L0 2.4V0Z" fill="#0066ff"/>
          </marker>
        </defs>
    )
}
